import { memo, useContext } from 'react';
import { Navigate } from 'react-router-dom';

import {
  CONFIG_STYLES,
  DESCRIPTION_AUTHENTICATE,
  ITEMS_CARD,
  LABEL_BTN_SIGN,
  TITLE,
} from './constants';
import { InfoCard } from '../../components';
import { AuthContext } from '../../store/AuthContext';
import { routes } from '../../models';

export const SignDocument = memo(() => {
  const { isAuthenticated, redirectToLogin } = useContext(AuthContext);

  if (isAuthenticated) {
    return <Navigate to={routes.documentSign} replace />;
  }

  return (
    <section className="container mt-5 p-5">
      <h3 className="pb-4">{TITLE}</h3>
      <div className="row g-3 mt-4">
        {ITEMS_CARD.map((item, idx) => (
          <InfoCard
            key={idx}
            icon={item.icon}
            altIcon={item.altIcon}
            title={item.title}
            description={item.description}
            img={item.img}
            configStyle={CONFIG_STYLES}
          />
        ))}
      </div>
      {!isAuthenticated && (
        <div className="mt-4 fs-6">
          <p>{DESCRIPTION_AUTHENTICATE}</p>
          <button onClick={redirectToLogin} className="btn btn-primary">
            {LABEL_BTN_SIGN}
          </button>
        </div>
      )}
    </section>
  );
});
